const FZ_CDN = "https://irp.cdn-website.com/a60ff280/dms3rep/multi/opt";
const COSTAO_CDN = "https://cms.costao.com.br/assets";
const MORADA_CDN = "https://www.moradadoscanyons.com/wp-content/uploads";
const ECOAR_CDN = "https://static.wixstatic.com/media";
const CERRO_CDN = "https://cerroazulhotelfazenda.com.br/wp-content/uploads/2022/08";

const eco = (file, w = 1600, h = 1000) =>
    `${ECOAR_CDN}/${file}/v1/fill/w_${w},h_${h},al_c,q_85,enc_avif,quality_auto/${file}`;

const ECOAR_IMGS = {
    hero: "f167d8_cefe74a854054e7497a7aae731be261e~mv2.png",
    poolView: "f167d8_4615a4b773ef46448f47ede7518130ee~mv2.png",
    aerial: "f167d8_95237eca00f4457a9690f654af9eec3d~mv2.png",
    lobby: "f167d8_c57767b8946042d5b714e34e8ad51803~mv2.png",
    family: "f167d8_3ceda1450d2e4629b4a06b5341e13f6d~mv2.png",
    picnic: "f167d8_d6be3c283017412aa23d408bffae9839~mv2.png",
    cheese: "f167d8_8dff24b2fde84b6aa3e8b70bba6c3bfd~mv2.png",
    fondue: "f167d8_09cb97cbd8824f8a9bb1e08516948e31~mv2.png",
    dishes: "f167d8_52f2978d344242cea87bb8e9052f829b~mv2.png",
    chale: "f167d8_ff82450939c9441f814be9ae87f0c6ca~mv2.png",
};

const MORADA_IMGS = {
    hero: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider9.webp`,
    villaPool: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider7.webp`,
    suiteHidro: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider8.webp`,
    tubs: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider4.webp`,
    spa: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider1.webp`,
    dish: `${MORADA_CDN}/2026/03/MoradaDosCanyons-Slider5.webp`,
    poolWine: `${MORADA_CDN}/2026/03/MoradaDosCanyons-EstruturaGaleriasPiscinas2.webp`,
    poolIndoor: `${MORADA_CDN}/2026/03/MoradaDosCanyons-EstruturaGaleriasPiscinas3.webp`,
    pool: `${MORADA_CDN}/2026/03/MoradaDosCanyons-EstruturaGaleriasPiscinas4.webp`,
    lagoon: `${MORADA_CDN}/2026/03/MoradaDosCanyons-EstruturaGaleriasLagoOrnamental2.webp`,
    romance: `${MORADA_CDN}/2026/03/MoradaDosCanyons-ExperienciasRomanticas-1.webp`,
    breakfast: `${MORADA_CDN}/2026/03/MoradaDosCanyons-EstruturaGaleriasCafeDaManha2.webp`,
    chale: `${MORADA_CDN}/2026/02/MoradaDosCanyons-Chale10.webp`,
    astro: `${MORADA_CDN}/2026/03/MoradaDosCanyons-RotaAstronomicaDosCanyons-1.webp`,
};

const COSTAO_IMGS = {
    aerial: `${COSTAO_CDN}/dfa37123-d6c4-454b-bb05-c8f5df0ebe23`,
    hotel: `${COSTAO_CDN}/4e30e8cd-f261-4b4d-9546-3350abb48361`,
    vilas: `${COSTAO_CDN}/0e17fc70-bfb1-459c-8d62-9b9ab7db0ecb`,
    sandboard: `${COSTAO_CDN}/8972633b-6207-4cb8-b86f-19d0eb4cc77b`,
    show: `${COSTAO_CDN}/26921f25-ea07-43bb-9cfb-7350f0f8bc30`,
    gastro: `${COSTAO_CDN}/63e75fdb-1c0b-4fbf-8e92-82a3df5fad66`,
    roomGarden: `${COSTAO_CDN}/27496c96-fdbe-42e3-b7da-e7b903826f4f`,
    livingSea: `${COSTAO_CDN}/4734b2d4-15c0-4c04-a33d-4f78a4cf571e`,
    roomSea: `${COSTAO_CDN}/60f5789a-315f-4f68-bdd7-59e6a16839a0`,
    roomBalcony: `${COSTAO_CDN}/7097ba04-d0f4-4da2-be21-5562dbf0b531`,
};

export const FAZZENDA_MEDIA = {
    hero: `${FZ_CDN}/54227071708_922dedc9f1_k-1920w.jpg`,
    pools: `${FZ_CDN}/PISCINAS+-+3+MIL+M--1920w.jpg`,
    kidsPool: `${FZ_CDN}/piscina1-1920w.jpg`,
    poolIndoor: `${FZ_CDN}/piscina3-1920w.jpg`,
    cavalgada: `${FZ_CDN}/CAVALGADA-1920w.jpg`,
    charrete: `${FZ_CDN}/CHARRETE-1920w.jpg`,
    arvorismo: `${FZ_CDN}/ARVORISMO-1920w.jpg`,
    pedalinho: `${FZ_CDN}/PEDALINHO-1920w.jpg`,
    jacuzzi: `${FZ_CDN}/JACUZZI-1920w.jpg`,
    esportes: `${FZ_CDN}/ESPORTES-1920w.jpg`,
    spa: `${FZ_CDN}/SPA+1-1920w.jpg`,
    cafe: `${FZ_CDN}/CAF%C3%89+DA+MANH%C3%83-1920w.jpg`,
    cafetarde: `${FZ_CDN}/CAF%C3%89+DA+TARDE-1920w.jpg`,
    almoco: `${FZ_CDN}/ALMO%C3%87O+1-1920w.jpg`,
    jantar: `${FZ_CDN}/JANTAR-1920w.jpg`,
    wineBar: `${FZ_CDN}/DSC04058-1920w.jpg`,
    bar: `${FZ_CDN}/DSC09749-Aprimorado-NR-1920w.jpg`,
    suco: `${FZ_CDN}/DSC08766.jpg-1920w.jpeg`,
    mascotes: `${FZ_CDN}/RECREA%C3%87%C3%83O-1920w.jpg`,
    animais: `${FZ_CDN}/NATUREZA+-+ANIMAIS-1920w.jpg`,
    horta: `${FZ_CDN}/NATUREZA+-+HORTA+ECOL%C3%93GICA-1920w.jpg`,
    lago: `${FZ_CDN}/DSC09271-1920w.jpg`,
    rancho: `${FZ_CDN}/53943011904_296a23f575_k-1920w.jpg`,
    standup: `${FZ_CDN}/STAND-UP+PADDLE-1920w.jpg`,
    pescaria: `${FZ_CDN}/PESCARIA-1920w.jpg`,
    bicicletas: `${FZ_CDN}/BICICLETAS-1920w.jpg`,
    brinquedoteca: `${FZ_CDN}/BRINQUEDOTECA-1920w.jpg`,
};

export const RESORTS = [
    {
        slug: "fazzenda-park-resort",
        name: "Fazzenda Park Resort",
        short: "Gaspar · SC",
        location: "Gaspar, Vale Europeu — Santa Catarina",
        badge: "All Inclusive no Campo",
        cardImage: FAZZENDA_MEDIA.hero,
        heroImage: FAZZENDA_MEDIA.hero,
        logoWhite: `${FZ_CDN}/fazenda-logo-2-1920w.png`,
        shortDescription:
            "2 milhões de m² de natureza com regime all inclusive: gastronomia colonial completa, bebidas inclusas, complexo de piscinas aquecidas, mini fazenda e recreação para todas as idades.",
        tags: ["All Inclusive", "Piscinas Aquecidas", "Turma do Gasparinho"],
        board: {
            regime: "All Inclusive",
            intro: "Gastronomia completa e bebidas inclusas durante toda a estadia, com piscinas, recreação e lazer para todas as idades.",
            included: [
                "Todas as refeições: café colonial, almoço, café da tarde e jantar",
                "Bebidas inclusas no regime all inclusive",
                "Complexo de piscinas, incluindo piscinas aquecidas",
                "Recreação diária com a Turma do Gasparinho",
                "Lazer completo: mini fazenda, trilhas, esportes e shows",
            ],
            extras: [
                "Alguns serviços e experiências especiais podem ser cobrados à parte — confirmamos todos os detalhes na sua cotação.",
            ],
        },
        extended: true,
        highlights: [],
        gallery: [],
    },
    {
        slug: "costao-do-santinho-resort",
        name: "Costão do Santinho Resort",
        short: "Florianópolis · SC",
        location: "Praia do Santinho, Florianópolis — Santa Catarina",
        badge: "All Inclusive Pé na Areia",
        cardImage: COSTAO_IMGS.aerial,
        heroImage: COSTAO_IMGS.aerial,
        shortDescription:
            "Entre mar, dunas e Mata Atlântica preservada: all inclusive premiado, piscinas aquecidas e cobertas e programação para o dia todo.",
        tags: ["All Inclusive", "Pé na Areia", "Piscinas Aquecidas"],
        board: {
            regime: "All Inclusive",
            intro: "Gastronomia, bebidas, praia, piscinas, esportes e entretenimento inclusos na diária.",
            included: [
                "Gastronomia completa nos restaurantes do resort",
                "Bebidas e drinks inclusos",
                "Praia do Santinho, piscinas aquecidas e cobertas",
                "Esportes, recreação e atividades para todas as idades",
                "Entretenimento e shows noturnos",
            ],
            extras: [
                "Determinados serviços e experiências premium são cobrados à parte — detalhamos tudo na sua cotação.",
            ],
        },
        extended: false,
        highlights: [
            "All inclusive completo: gastronomia, drinks e entretenimento",
            "Mar, dunas e um santuário de Mata Atlântica preservada",
            "Piscinas aquecidas e cobertas para curtir o ano inteiro",
            "Recreação premiada para crianças, teens e adultos",
        ],
        marquee: ["All Inclusive", "Pé na Areia", "Piscinas Aquecidas", "Recreação Premiada", "Alta Gastronomia", "Vilas Portuguesas", "Shows Noturnos", "Santuário Ecológico"],
        videos: [{ id: "_TUU487uR38", title: "Tour virtual oficial pelo Costão do Santinho" }],
        experience: {
            eyebrow: "A Experiência Costão",
            title: "All inclusive à beira do paraíso",
            intro: "Entre a Praia do Santinho e um santuário de Mata Atlântica, o Costão combina estrutura de resort internacional com o charme da Ilha da Magia.",
            big: { img: COSTAO_IMGS.sandboard, label: "Aventura nas Dunas", sub: "Sandboard e experiências ao ar livre no Santinho" },
            textCard: {
                chip: "All Inclusive",
                title: "Do café da manhã aos shows da noite, tudo incluso",
                bullets: ["Restaurantes e alta gastronomia", "Drinks e petiscos inclusos", "Shows e entretenimento noturno", "Piscinas aquecidas e cobertas"],
                foot: "Sem surpresas no check-out",
            },
            small1: { img: COSTAO_IMGS.vilas, label: "Vilas Portuguesas" },
            goldCard: {
                chip: "Praia do Santinho",
                title: "Mar, dunas e mata preservada",
                text: "Um santuário ecológico com trilhas, arte rupestre e uma das praias mais cênicas de Florianópolis.",
            },
            small2: { img: COSTAO_IMGS.gastro, label: "Alta Gastronomia" },
        },
        audiences: [
            {
                id: "familias",
                icon: "Baby",
                title: "Famílias com Crianças",
                text: "Recreação premiada e programação o dia todo, com tranquilidade para os pais.",
                bullets: ["Clubinho kids e espaço teen", "Piscinas com área infantil", "Shows e atividades em família", "All inclusive sem preocupação"],
                img: COSTAO_IMGS.show,
                imgAlt: "Show noturno no teatro do resort",
            },
            {
                id: "casais",
                icon: "Heart",
                title: "Casais & Romance",
                text: "Pé na areia, gastronomia premiada e pôr do sol sobre as dunas.",
                bullets: ["Jantares em restaurantes temáticos", "Drinks ao pôr do sol", "Caminhadas na praia preservada", "Spa e áreas de relaxamento"],
                img: COSTAO_IMGS.livingSea,
                imgAlt: "Living com varanda de frente para o mar",
            },
            {
                id: "grupos",
                icon: "Users",
                title: "Grupos & Eventos",
                text: "Estrutura de resort internacional para eventos e convenções à beira-mar.",
                bullets: ["Centro de convenções completo", "Hotel e vilas para grandes grupos", "Eventos pé na areia", "Pacotes corporativos sob medida"],
                img: COSTAO_IMGS.aerial,
                imgAlt: "Vista aérea do resort entre a praia e a mata",
            },
        ],
        gallery: [
            { id: "costao-1", src: COSTAO_IMGS.aerial, alt: "Resort entre a praia e a mata atlântica" },
            { id: "costao-2", src: COSTAO_IMGS.hotel, alt: "Hotel Internacional e complexo de piscinas" },
            { id: "costao-3", src: COSTAO_IMGS.vilas, alt: "Vilas Portuguesas floridas" },
            { id: "costao-4", src: COSTAO_IMGS.sandboard, alt: "Sandboard nas dunas do Santinho" },
            { id: "costao-5", src: COSTAO_IMGS.show, alt: "Show noturno no teatro do resort" },
            { id: "costao-6", src: COSTAO_IMGS.gastro, alt: "Alta gastronomia inclusa no all inclusive" },
            { id: "costao-7", src: COSTAO_IMGS.roomGarden, alt: "Quarto com vista para o jardim" },
            { id: "costao-8", src: COSTAO_IMGS.livingSea, alt: "Living com varanda de frente para o mar" },
            { id: "costao-9", src: COSTAO_IMGS.roomSea, alt: "Quarto com varanda e vista para o mar" },
            { id: "costao-10", src: COSTAO_IMGS.roomBalcony, alt: "Suíte com varanda" },
        ],
    },
    {
        slug: "morada-dos-canyons",
        name: "Morada dos Canyons",
        short: "Praia Grande · SC",
        location: "Praia Grande, Serra Catarinense — SC · ao lado do Itaimbezinho",
        badge: "Hotel Boutique nos Cânions",
        cardImage: MORADA_IMGS.hero,
        heroImage: MORADA_IMGS.hero,
        shortDescription:
            "Hotel & spa boutique entre os cânions da Serra Catarinense: vilas com piscina privativa, silêncio e um dos céus mais estrelados do país.",
        tags: ["Cânions & Mirantes", "Spa & Bem-estar", "Romance a Dois"],
        board: {
            regime: "Café da manhã incluso",
            intro: "Hospedagem boutique em chalés, suítes e casas de campo, com o café da manhã da serra incluso na diária. Demais refeições e experiências são contratadas à parte.",
            included: [
                "Café da manhã da serra incluso na diária",
                "Chalés, suítes e casas de campo de arquitetura boutique",
                "Piscinas aquecidas — algumas acomodações com piscina privativa",
                "Morada Spa com piscina de borda infinita e saunas",
                "Experiências românticas e astroturismo na Rota Astronômica dos Canyons",
            ],
            extras: [
                "Almoço, jantar e experiências gastronômicas sob consulta",
                "Terapias e massagens do spa conforme disponibilidade — consultamos as condições na cotação",
            ],
        },
        extended: false,
        highlights: [
            "Vilas com piscina privativa de frente para os cânions",
            "Suítes com hidromassagem, calefação e telescópio",
            "Rota Astronômica dos Canyons: astroturismo oficial",
            "Gastronomia autoral com ingredientes da serra",
        ],
        marquee: ["Cânions & Mirantes", "Spa & Bem-estar", "Astroturismo", "Vilas com Piscina", "Gastronomia de Serra", "Romance a Dois"],
        videos: [
            { id: "BzJPzhUVUAk", title: "Morada Spa — Destinos Imperdíveis" },
            { id: "nBtsOx7H_Tc", title: "Morada dos Canyons por dentro" },
        ],
        experience: {
            eyebrow: "A Experiência Morada",
            title: "Silêncio, paredões e céu estrelado",
            intro: "Entre Praia Grande e Cambará do Sul, a Morada dos Canyons é um boutique hotel de montanha feito para desacelerar — com os cânions como cenário.",
            big: { img: MORADA_IMGS.villaPool, label: "Vilas com Piscina Privativa", sub: "Piscina aquecida só sua, de frente para os paredões" },
            textCard: {
                chip: "Spa & Bem-estar",
                title: "Desacelerar é o programa",
                bullets: ["Spa com terapias relaxantes", "Banheiras com vista para os cânions", "Café da manhã servido com calma", "Experiências românticas sob medida"],
                foot: "Boutique: poucas unidades, muito cuidado",
            },
            small1: { img: MORADA_IMGS.suiteHidro, label: "Suítes com Hidro & Telescópio" },
            goldCard: {
                chip: "Rota Astronômica",
                title: "Um dos céus mais estrelados do país",
                text: "Astroturismo oficial: estrelas e constelações em uma das regiões de céu mais escuro do Sul do Brasil.",
            },
            small2: { img: MORADA_IMGS.breakfast, label: "Café da Manhã com Vista" },
        },
        audiences: [
            {
                id: "casais",
                icon: "Heart",
                title: "Casais & Romance",
                text: "O refúgio definitivo para comemorar a dois, acima das nuvens.",
                bullets: ["Vilas privativas com piscina", "Lareira externa e espumante ao entardecer", "Spa a dois", "Jantares especiais na serra"],
                img: MORADA_IMGS.romance,
                imgAlt: "Casal no deck com lareira e vista para os cânions",
            },
            {
                id: "aventura",
                icon: "Mountain",
                title: "Aventureiros & Natureza",
                text: "A base perfeita para explorar a maior concentração de cânions do Brasil.",
                bullets: ["Cânion Itaimbezinho ao lado", "Trilhas e mirantes da serra", "Rota astronômica oficial", "Passeios guiados pela região"],
                img: MORADA_IMGS.astro,
                imgAlt: "Céu estrelado da Rota Astronômica dos Canyons",
            },
            {
                id: "bem-estar",
                icon: "Sparkles",
                title: "Bem-estar & Descanso",
                text: "Para quem precisa desligar: silêncio, spa e tempo em câmera lenta.",
                bullets: ["Spa completo com terapias", "Piscinas com vista infinita", "Silêncio e desconexão", "Gastronomia leve da serra"],
                img: MORADA_IMGS.spa,
                imgAlt: "Massagem relaxante no spa da Morada",
            },
        ],
        gallery: [
            { id: "morada-1", src: MORADA_IMGS.hero, alt: "Deck com banheira acima das nuvens ao pôr do sol" },
            { id: "morada-2", src: MORADA_IMGS.villaPool, alt: "Casal na piscina privativa da vila" },
            { id: "morada-3", src: MORADA_IMGS.suiteHidro, alt: "Suíte com hidromassagem, telescópio e vista para o cânion" },
            { id: "morada-4", src: MORADA_IMGS.tubs, alt: "Banheiras duplas com vista para as montanhas" },
            { id: "morada-5", src: MORADA_IMGS.spa, alt: "Experiência de spa na Morada dos Canyons" },
            { id: "morada-6", src: MORADA_IMGS.poolWine, alt: "Piscina de borda infinita com vista para os cânions" },
            { id: "morada-7", src: MORADA_IMGS.poolIndoor, alt: "Piscina coberta com vista panorâmica" },
            { id: "morada-8", src: MORADA_IMGS.pool, alt: "Piscina da Morada dos Canyons" },
            { id: "morada-9", src: MORADA_IMGS.lagoon, alt: "Lago ornamental natural entre os jardins" },
            { id: "morada-10", src: MORADA_IMGS.romance, alt: "Experiência romântica no deck com lareira" },
            { id: "morada-11", src: MORADA_IMGS.breakfast, alt: "Café da manhã com vista para os paredões" },
            { id: "morada-12", src: MORADA_IMGS.dish, alt: "Gastronomia autoral da serra" },
            { id: "morada-13", src: MORADA_IMGS.chale, alt: "Chalé entre a mata e os cânions" },
            { id: "morada-14", src: MORADA_IMGS.astro, alt: "Céu estrelado da Rota Astronômica dos Canyons" },
        ],
    },
    {
        slug: "resort-ecoar",
        name: "Resort Ecoar",
        short: "Gaspar · SC",
        location: "Gaspar, Vale Europeu — Santa Catarina",
        badge: "Aconchego no Vale",
        cardImage: eco(ECOAR_IMGS.hero, 1905, 1100),
        heroImage: eco(ECOAR_IMGS.hero, 1905, 1100),
        shortDescription:
            "Aconchego em meio à natureza: pensão completa com café colonial, chalés premium com vista para o vale e uma recreação que conquista as crianças.",
        tags: ["Pensão Completa", "Chalés Premium", "Recreação Familiar"],
        board: {
            regime: "Pensão completa · 4 refeições",
            intro: "Regime de pensão completa com quatro refeições inclusas na diária: café da manhã, almoço, café da tarde e jantar.",
            included: [
                "Café da manhã, almoço, café da tarde e jantar inclusos",
                "Piscinas aquecidas, incluindo a borda infinita com vista para o vale",
                "Jacuzzis ao ar livre",
                "Recreação diária e atividades na natureza",
                "Acesso ao Parque Aquático Cascanéia durante a hospedagem",
            ],
            extras: [
                "O Parque Cascanéia funciona conforme calendário e condições oficiais do parque — confirmamos a disponibilidade para as suas datas.",
            ],
        },
        extended: false,
        highlights: [
            "Pensão completa: café colonial, almoços e jantares temáticos",
            "Chalés Premium da Vila Primavera com vista para o vale",
            "Piscina de borda infinita de frente para as montanhas",
            "Recreação elogiada e cuidadosa com as crianças",
        ],
        marquee: ["Pensão Completa", "Café Colonial", "Chalés Premium", "Borda Infinita", "Recreação Familiar", "Fondue no Deck"],
        videos: [{ id: "uM0B27TqdBM", title: "Refúgio em Gaspar — vídeo oficial do Ecoar" }],
        experience: {
            eyebrow: "A Experiência Ecoar",
            title: "Aconchego de fazer virar tradição",
            intro: "No coração do Vale Europeu, o Ecoar é aquele resort de família onde cada refeição é um evento e cada entardecer vira piquenique.",
            big: { img: eco(ECOAR_IMGS.poolView), label: "Piscina de Borda Infinita", sub: "De frente para as montanhas do vale" },
            textCard: {
                chip: "Pensão Completa",
                title: "Café colonial, almoços e jantares temáticos",
                bullets: ["Café colonial da roça", "Almoços fartos e caseiros", "Café da tarde no deck", "Jantares temáticos à noite"],
                foot: "As 4 refeições inclusas na diária",
            },
            small1: { img: eco(ECOAR_IMGS.aerial), label: "Chalés entre a Neblina" },
            goldCard: {
                chip: "Vila Primavera",
                title: "Chalés premium com vista para o vale",
                text: "Acomodações novas e aconchegantes, pensadas para casais e famílias que buscam conforto no meio da natureza.",
            },
            small2: { img: eco(ECOAR_IMGS.family), label: "Diversão em Família" },
        },
        audiences: [
            {
                id: "familias",
                icon: "Baby",
                title: "Famílias com Crianças",
                text: "Recreação cuidadosa e espaço de sobra para as crianças gastarem energia.",
                bullets: ["Recreação elogiada pelas famílias", "Jardins e espaços ao ar livre", "Refeições inclusas o dia todo", "Ambiente seguro e familiar"],
                img: eco(ECOAR_IMGS.family),
                imgAlt: "Família nos jardins do resort",
            },
            {
                id: "casais",
                icon: "Heart",
                title: "Casais & Romance",
                text: "Borda infinita, fondue no deck e o vale inteiro só para vocês.",
                bullets: ["Chalés premium privativos", "Piscina de borda infinita", "Fondue ao pôr do sol", "Piqueniques no jardim"],
                img: eco(ECOAR_IMGS.hero),
                imgAlt: "Casal brindando na piscina de borda infinita",
            },
            {
                id: "grupos",
                icon: "Users",
                title: "Grupos & Confraternizações",
                text: "Espaços de convivência e mesa farta para celebrar em grupo.",
                bullets: ["Espaços amplos de convivência", "Pacotes para excursões", "Jantares temáticos para grupos", "Localização prática no Vale Europeu"],
                img: eco(ECOAR_IMGS.fondue),
                imgAlt: "Jantar de fondue com vista para os chalés",
            },
        ],
        gallery: [
            { id: "ecoar-1", src: eco(ECOAR_IMGS.hero), alt: "Casal na piscina de borda infinita" },
            { id: "ecoar-2", src: eco(ECOAR_IMGS.poolView), alt: "Piscina com vista para as montanhas" },
            { id: "ecoar-3", src: eco(ECOAR_IMGS.aerial), alt: "Vista aérea dos chalés entre a neblina do vale" },
            { id: "ecoar-4", src: eco(ECOAR_IMGS.lobby), alt: "Lobby com paredes de vidro e vista para a natureza" },
            { id: "ecoar-5", src: eco(ECOAR_IMGS.chale), alt: "Interior aconchegante do chalé premium" },
            { id: "ecoar-6", src: eco(ECOAR_IMGS.family), alt: "Família nos jardins do resort" },
            { id: "ecoar-7", src: eco(ECOAR_IMGS.picnic), alt: "Piquenique em família no deck" },
            { id: "ecoar-8", src: eco(ECOAR_IMGS.fondue), alt: "Fondue servido no deck ao entardecer" },
            { id: "ecoar-9", src: eco(ECOAR_IMGS.cheese), alt: "Tábua de queijos e frios do café colonial" },
            { id: "ecoar-10", src: eco(ECOAR_IMGS.dishes), alt: "Pratos da gastronomia do Ecoar" },
        ],
    },
    {
        slug: "cerro-azul-hotel-fazenda",
        name: "Cerro Azul Hotel Fazenda",
        short: "Capão Alto · SC",
        location: "Coxilha Rica, Capão Alto, Serra Catarinense — SC",
        badge: "Boutique de Fazenda",
        cardImage: `${CERRO_CDN}/DJI_0124.jpg`,
        heroImage: `${CERRO_CDN}/DJI_0080.jpg`,
        shortDescription:
            "Hotel fazenda boutique em uma fazenda ativa de 700 hectares: cavalgadas com campeiros, golf rural, parreiras de uva e o pôr do sol mais famoso da serra.",
        tags: ["Fazenda Ativa", "Cavalgadas & Golf Rural", "Suítes com Hidro"],
        board: {
            regime: "Pensão completa",
            intro: "Refeições inclusas na diária em regime de pensão completa, com gastronomia regional de fazenda. Bebidas e determinados serviços são cobrados separadamente.",
            included: [
                "Refeições em pensão completa com gastronomia regional",
                "Fazenda ativa de 700 hectares com experiências rurais",
                "Cavalgadas acompanhadas por campeiros",
                "Contato com os animais da fazenda",
                "Piscina aquecida e adega no salão principal",
            ],
            extras: [
                "Bebidas, incluindo os rótulos da adega, são cobradas à parte",
                "Determinados serviços e experiências têm custo adicional — detalhamos na cotação",
            ],
        },
        extended: false,
        highlights: [
            "Fazenda ativa com cavalos Quarto de Milha, gado e pomar",
            "Cavalgadas acompanhadas por campeiros e golf rural nos campos",
            "Hidromassagem com vista para os parreirais de uva",
            "Suítes com calefação, lareiras e amenities L'Occitane",
        ],
        marquee: ["Fazenda Ativa", "Cavalgadas", "Golf Rural", "Suítes com Hidro", "Coxilha Rica", "Gastronomia de Fazenda"],
        videos: [
            { id: "Avq5IcqdLEU", title: "Conheça o Cerro Azul — vídeo oficial" },
            { id: "D-hQDHkLex4", title: "Apresentação Cerro Azul Hotel Fazenda" },
        ],
        experience: {
            eyebrow: "A Experiência Cerro Azul",
            title: "A vida de fazenda com alma boutique",
            intro: "Na Coxilha Rica, entre os campos de cima da serra, o Cerro Azul é uma fazenda ativa de 700 hectares que recebe como hotel boutique.",
            big: { img: `${CERRO_CDN}/banner1.jpg`, label: "Salão com Lareira & Vista", sub: "Arquitetura rústica com conforto de hotel boutique" },
            textCard: {
                chip: "Fazenda Ativa",
                title: "700 hectares de vida no campo",
                bullets: ["Cavalos Quarto de Milha", "Cavalgadas com campeiros", "Golf rural nos campos", "Pomar e parreiras de uva"],
                foot: "Autenticidade de fazenda boutique",
            },
            small1: { img: `${CERRO_CDN}/Apto_41_0438_Cobaltolago-1.jpg`, label: "Suíte Cobalto com Hidro" },
            goldCard: {
                chip: "Pôr do Sol",
                title: "O entardecer mais famoso da serra",
                text: "Fogueira, vinho e o sol se pondo sobre a Coxilha Rica — o momento mais pedido pelos hóspedes.",
            },
            small2: { img: `${CERRO_CDN}/MG_1062-1.jpg`, label: "Fogueira ao Entardecer" },
        },
        audiences: [
            {
                id: "casais",
                icon: "Heart",
                title: "Casais & Romance",
                text: "Suítes com hidro, lareiras e o pôr do sol da Coxilha Rica.",
                bullets: ["Suítes com hidro e calefação", "Amenities L'Occitane", "Jantares a luz de velas", "Pôr do sol com espumante"],
                img: `${CERRO_CDN}/Apto_41_0438_Cobaltolago-1.jpg`,
                imgAlt: "Banheira na varanda da suíte com vista para o lago",
            },
            {
                id: "familias",
                icon: "Baby",
                title: "Famílias & Natureza",
                text: "Liberdade de fazenda para as crianças, conforto de hotel para os pais.",
                bullets: ["Cavalgadas para todas as idades", "Contato com os animais da fazenda", "Golf rural em família", "Espaço e liberdade com segurança"],
                img: `${CERRO_CDN}/DJI_0124.jpg`,
                imgAlt: "Vista aérea do hotel fazenda na Coxilha Rica",
            },
            {
                id: "eventos",
                icon: "Users",
                title: "Casamentos & Eventos",
                text: "Um cenário cinematográfico nos campos de cima da serra.",
                bullets: ["Cenário único para casamentos", "Salões com lareira", "Hospedagem para convidados", "Produção completa de eventos"],
                img: `${CERRO_CDN}/banner1.jpg`,
                imgAlt: "Salão principal do Cerro Azul",
            },
        ],
        gallery: [
            { id: "cerro-1", src: `${CERRO_CDN}/DJI_0080.jpg`, alt: "Vista aérea do Cerro Azul na Coxilha Rica" },
            { id: "cerro-2", src: `${CERRO_CDN}/DJI_0124.jpg`, alt: "O hotel fazenda entre os campos da serra" },
            { id: "cerro-3", src: `${CERRO_CDN}/banner1.jpg`, alt: "Salão de convivência com lareira" },
            { id: "cerro-4", src: `${CERRO_CDN}/Apto_41_0438_Cobaltolago-1.jpg`, alt: "Suíte Cobalto: banheira na varanda com vista para o lago" },
            { id: "cerro-5", src: `${CERRO_CDN}/MG_1062-1.jpg`, alt: "Fogueira ao entardecer na fazenda" },
        ],
    },
];

export const getResort = (slug) => RESORTS.find((r) => r.slug === slug);

export const RESORT_OPTIONS = [
    ...RESORTS.map((r) => ({ value: r.slug, label: `${r.name} (${r.short})` })),
    { value: "outro", label: "Outro / Quero recomendação personalizada" },
];

export const FAZZENDA = RESORTS[0];

export const FAZZENDA_OFFICIAL = {
    address: "Rua João Mathias Zimmermann, 2299 — Gaspar · SC",
    maps: "https://maps.app.goo.gl/RetGyvLknGrc6XGRA",
    phone: "(47) 3397-9000",
    email: "contato@fazzenda.com.br",
    site: "https://www.fazzenda.com.br",
    note: "Conteúdo visual oficial, autorizado via Portal do Parceiro Fazzenda Park Resort.",
};

export const FAZZENDA_AWARDS = [
    { img: `${FZ_CDN}/tchotel_2024_LL-640w.png`, label: "Tripadvisor Travellers' Choice 2024" },
    { img: `${FZ_CDN}/10-tc_2023_botb_ll_transparent_bg-640w.png`, label: "Tripadvisor Travellers' Choice 2023" },
    { img: `${FZ_CDN}/8-selo_vetor-640w.png`, label: "Selo Verde · Sustentabilidade" },
];

export const FAZZENDA_VIDEOS = [
    { id: "BSrZykSpTO8", title: "7 refeições por dia? A cozinha do Fazzenda" },
    { id: "3O89TExnc0Q", title: "Um dia no rancho: a rotina do campo" },
    { id: "CEs4zUGVBQw", title: "As novas acomodações do resort" },
];

export const FAZZENDA_MARQUEE = [
    "Pensão Completa",
    "Piscinas Aquecidas",
    "Cavalgadas & Charretes",
    "Turma do Gasparinho",
    "Mini Fazenda",
    "Gastronomia Típica",
    "Wine Bar",
    "Shows Noturnos",
];

export const FAZZENDA_GALLERY_TABS = [
    { id: "todas", label: "Todas" },
    { id: "lazer", label: "Piscinas & Lazer" },
    { id: "aventura", label: "Aventura & Fazenda" },
    { id: "gastronomia", label: "Gastronomia" },
];

export const FAZZENDA_GALLERY = [
    { id: "fz-pools", src: FAZZENDA_MEDIA.pools, alt: "Complexo de piscinas e hidromassagens aquecidas", cats: ["lazer"] },
    { id: "fz-hero", src: FAZZENDA_MEDIA.hero, alt: "Vista aérea do resort entre os morros do Vale Europeu", cats: ["lazer"] },
    { id: "fz-kidspool", src: FAZZENDA_MEDIA.kidsPool, alt: "Parque aquático infantil com toboáguas", cats: ["lazer"] },
    { id: "fz-jacuzzi", src: FAZZENDA_MEDIA.jacuzzi, alt: "Hidromassagem aquecida entre os bambus", cats: ["lazer"] },
    { id: "fz-pedalinho", src: FAZZENDA_MEDIA.pedalinho, alt: "Passeio de pedalinho no lago", cats: ["lazer"] },
    { id: "fz-standup", src: FAZZENDA_MEDIA.standup, alt: "Stand-up paddle no lago", cats: ["lazer"] },
    { id: "fz-piscina3", src: FAZZENDA_MEDIA.poolIndoor, alt: "Piscina coberta e aquecida", cats: ["lazer"] },
    { id: "fz-esportes", src: FAZZENDA_MEDIA.esportes, alt: "Esportes na areia e quadras do resort", cats: ["lazer"] },
    { id: "fz-brinquedoteca", src: FAZZENDA_MEDIA.brinquedoteca, alt: "Brinquedoteca monitorada para as crianças", cats: ["lazer"] },
    { id: "fz-lago", src: FAZZENDA_MEDIA.lago, alt: "Lago, ciclovia e jardins do resort", cats: ["lazer", "aventura"] },
    { id: "fz-bicicletas", src: FAZZENDA_MEDIA.bicicletas, alt: "Passeio de bicicleta ao redor do lago", cats: ["lazer", "aventura"] },
    { id: "fz-cavalgada", src: FAZZENDA_MEDIA.cavalgada, alt: "Cavalgada guiada pela fazenda", cats: ["aventura"] },
    { id: "fz-charrete", src: FAZZENDA_MEDIA.charrete, alt: "Passeio de charrete em família", cats: ["aventura"] },
    { id: "fz-arvorismo", src: FAZZENDA_MEDIA.arvorismo, alt: "Arvorismo no bosque do resort", cats: ["aventura"] },
    { id: "fz-animais", src: FAZZENDA_MEDIA.animais, alt: "Mini fazenda: contato com os animais", cats: ["aventura"] },
    { id: "fz-rancho", src: FAZZENDA_MEDIA.rancho, alt: "Vivência no rancho: ordenha da tarde", cats: ["aventura"] },
    { id: "fz-pescaria", src: FAZZENDA_MEDIA.pescaria, alt: "Pescaria em família no lago", cats: ["aventura"] },
    { id: "fz-horta", src: FAZZENDA_MEDIA.horta, alt: "Horta ecológica: colheita com as crianças", cats: ["aventura"] },
    { id: "fz-cafe", src: FAZZENDA_MEDIA.cafe, alt: "Café da manhã colonial", cats: ["gastronomia"] },
    { id: "fz-cafetarde", src: FAZZENDA_MEDIA.cafetarde, alt: "Café da tarde com cucas e bolos", cats: ["gastronomia"] },
    { id: "fz-almoco", src: FAZZENDA_MEDIA.almoco, alt: "Almoço típico preparado na hora", cats: ["gastronomia"] },
    { id: "fz-jantar", src: FAZZENDA_MEDIA.jantar, alt: "Jantares e pizzaria à noite", cats: ["gastronomia"] },
    { id: "fz-winebar", src: FAZZENDA_MEDIA.wineBar, alt: "Brindes no Wine Bar Fazzenda", cats: ["gastronomia"] },
    { id: "fz-bar", src: FAZZENDA_MEDIA.bar, alt: "Wine Bar Fazzenda", cats: ["gastronomia"] },
    { id: "fz-suco", src: FAZZENDA_MEDIA.suco, alt: "Sucos naturais no café da manhã", cats: ["gastronomia"] },
];

export const FAZZENDA_AUDIENCES = [
    {
        id: "familias",
        icon: "Baby",
        title: "Famílias com Crianças",
        text: "Dias inteiros de diversão com a Turma do Gasparinho e tranquilidade para os pais.",
        bullets: ["Recreação monitorada o dia todo", "Mini fazenda e contato com animais", "Parque aquático infantil", "Refeições inclusas para toda a família"],
        img: FAZZENDA_MEDIA.mascotes,
        imgAlt: "Turma do Gasparinho, os mascotes do resort",
    },
    {
        id: "casais",
        icon: "Heart",
        title: "Casais & Romance",
        text: "O refúgio perfeito para desacelerar e reconectar, em meio à natureza.",
        bullets: ["Hidromassagem aquecida entre os bambus", "Spa e massagens relaxantes", "Wine Bar e jantares especiais", "Pôr do sol sobre os campos e o lago"],
        img: FAZZENDA_MEDIA.jacuzzi,
        imgAlt: "Casal na hidromassagem do spa do resort",
    },
    {
        id: "grupos",
        icon: "Users",
        title: "Grupos & Eventos",
        text: "Estrutura completa para confraternizações, excursões e encontros corporativos.",
        bullets: ["Espaços amplos para eventos", "Pacotes sob medida para grupos", "Day use e hospedagem combinados", "Charretes, esportes e vivências de fazenda"],
        img: FAZZENDA_MEDIA.charrete,
        imgAlt: "Passeio de charrete com o resort ao fundo",
    },
];
